import { Dispatch, ThunkAction } from '../../../../../../types/actions';
import { IGetState } from '../../../../../../types/types';
import { changeViewType } from '../../../effects/changeViewType';
import { getLastKanbanView } from '../helpers/lastKanbanViewHelper';
import { getTypeSwitcherActiveType } from '../../../store/selectors/getTypeSwitcherActiveType';
import { getActiveBoardId } from '../../../../../../store/model/selectors/getActiveBoardId';
import { VIEW_TYPES_KANBAN_OTHER, VIEW_TYPES_SWIM } from '../../../../../../const';

export const onLastKanbanViewOpen = (
    onClose: () => void,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        if (document.querySelector('.touch')) return;
        const state = getState();
        const boardId = getActiveBoardId(state);
        const activeView = getTypeSwitcherActiveType(state, boardId);
        if ([...VIEW_TYPES_KANBAN_OTHER, ...VIEW_TYPES_SWIM].includes(activeView)) {
            return;
        }
        dispatch(changeViewType(getLastKanbanView()));
        onClose();
    };
    return action;
};
